class CreditCardInstallmentsUIModel {
  constructor(installment) {
    if (typeof installment !== 'number') {
      this.numberOfMonths = installment.numberOfMonths;
      this.ancillaryCode = installment.ancillaryCode;
      this.installmentFee = installment.installmentFee;
    } else {
      this.numberOfMonths = installment;
    }
  }
}

export default CreditCardInstallmentsUIModel;